// extracted by mini-css-extract-plugin
export var avatarContainer = "_93-0";
export var avatarTypingWave = "_93-i";
export var gray = "_93-f";
export var green = "_93-c";
export var icon = "_93-9";
export var image = "_93-1";
export var lg = "_93-6";
export var md = "_93-5";
export var presenceDot = "_93-b";
export var red = "_93-d";
export var sm = "_93-4";
export var status = "_93-a";
export var typingDot = "_93-h";
export var typingPill = "_93-g";
export var xl = "_93-7";
export var xs = "_93-3";
export var xxl = "_93-8";
export var xxs = "_93-2";
export var yellow = "_93-e";